var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contextual-dialog-bulk',_vm._b({attrs:{"value":_vm.isAlertVisible},on:{"input":_vm.handleVisibilityChange}},'contextual-dialog-bulk',_vm.dialogOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }